import { Booking } from '@shared/types';
import { PublicCourse, PublicEducator } from '@cademy-package/sdk-component-types';
import { FunctionComponent, useEffect, useState } from 'react';
import { useBookingLink } from '../../../../../../hooks/useBookingLink';
import styles from '../../styles.module.scss';
import { CademyError } from '@shared/domain-shared';
import ButtonLink from '../../../../../ButtonLink';

type ViewMyBookingButtonProps = {
    bookingId: Booking['_id'];
    courseSlug: PublicCourse['slug'];
    educatorSlug: PublicEducator['slug'];
};

export const ViewMyBookingButton: FunctionComponent<ViewMyBookingButtonProps> = ({
    bookingId,
    courseSlug,
    educatorSlug,
}) => {
    const [bookingDetails, setBookingDetails] = useState<Booking | null>(null);

    const bookingLink = useBookingLink({
        educatorSlug,
        occurrenceId: bookingDetails ? bookingDetails.occurrence_ref : null,
        courseSlug,
        bookingId,
    });

    useEffect(() => {
        const getBookingDetails = async () => {
            try {
                const result = await fetch(
                    `${process.env.NEXT_PUBLIC_CADEMY_API_URL}/bookings/${bookingId}`
                );
                if (!result.ok) {
                    const error = await result.json();
                    throw CademyError.fromUnknown(error);
                }
                const booking: Booking = await result.json();
                setBookingDetails(booking);
            } catch (err) {
                console.error('Error fetching booking data', err);
            }
        };
        if (bookingId) {
            getBookingDetails();
        }
    }, [bookingId]);

    if (!bookingDetails) {
        return null;
    }

    return (
        <ButtonLink {...bookingLink} preset="primary" className={styles.accessEnrolmentButton}>
            View My Booking
        </ButtonLink>
    );
};
